import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import classes from './ProductCta.module.scss';

// Main call-to-action of a product page. One look everywhere, so the user
// learns once what the "buy / apply" button looks like.
const ProductCta = ({ children, href, to, icon, block, compact, className }) => {
  const classNames = [
    classes.cta,
    block && classes.block,
    compact && classes.compact,
    className
  ]
    .filter(Boolean)
    .join(' ');

  const content = (
    <>
      {icon && <FontAwesomeIcon icon={icon} />}
      <span>{children}</span>
      <span className={classes.arrow}>
        <FontAwesomeIcon icon={faArrowRight} />
      </span>
    </>
  );

  if (to) {
    return (
      <Link to={to} className={classNames} data-product-cta>
        {content}
      </Link>
    );
  }

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={classNames}
      data-product-cta>
      {content}
    </a>
  );
};

export default ProductCta;
